import type { MailboxInfo } from 'owa-client-types';
import { getAsyncItemRegistry } from './getAsyncItemRegistry';
import type { AsyncItemEntry } from '../store/schema/AsyncItemEntry';

/** Returns all tracked async items for an account. */
export function getAllAsyncItemEntries(mailboxInfo: MailboxInfo): AsyncItemEntry[] {
    return Array.from(getAsyncItemRegistry(mailboxInfo)?.entriesById.values() ?? []);
}
